import {
	GetObjectCommand,
	PutObjectCommand,
	S3Client,
} from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';

const region = process.env.REACT_APP_AWS_REGION || '';
const bucketName = process.env.REACT_APP_S3_BUCKET_NAME || '';
const keyPrefix = process.env.REACT_APP_S3_KEY_PREFIX || '';
const s3BaseUrl = `https://${bucketName}.s3.amazonaws.com`;

const s3Client = new S3Client({
	region,
	credentials: {
		accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || '',
		secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY || '',
	},
});

export async function uploadFileToS3(
	folderName: string,
	file: File,
): Promise<string> {
	if (!region || !bucketName) {
		throw new Error(
			'S3 is not configured. Set REACT_APP_AWS_REGION and REACT_APP_S3_BUCKET_NAME.',
		);
	}

	const safeFolderName = folderName.replace(/[^a-zA-Z0-9._-]/g, '_');
	const safeFileName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
	const key = `${keyPrefix}${safeFolderName}/${Date.now()}_${safeFileName}`;
	const fileBytes = new Uint8Array(await file.arrayBuffer());

	await s3Client.send(
		new PutObjectCommand({
			Bucket: bucketName,
			Key: key,
			Body: fileBytes,
			ContentLength: file.size,
			ContentType: file.type || 'application/octet-stream',
		}),
	);

	return `${s3BaseUrl}/${key}`;
}

export async function getS3PresignedUrl(
	objectUrl: string,
	expiresIn = 3600,
): Promise<string> {
	const key = getS3KeyFromObjectUrl(objectUrl);

	if (!key) {
		return objectUrl;
	}

	return getSignedUrl(
		s3Client,
		new GetObjectCommand({
			Bucket: bucketName,
			Key: key,
		}),
		{ expiresIn },
	);
}

function getS3KeyFromObjectUrl(objectUrl: string) {
	if (!bucketName) {
		return '';
	}

	try {
		const url = new URL(objectUrl);
		const s3Host = `${bucketName}.s3.amazonaws.com`;

		if (url.hostname !== s3Host) {
			return '';
		}

		return decodeURIComponent(url.pathname.replace(/^\//, ''));
	} catch {
		return '';
	}
}
